import { useEffect, useState } from "react";
import { accessTypes, accessTypeRoles } from "../../../../consts";

export const useHandleAdminRolesAvailability = ({
  roleOptions,
  selectedAccessType,
  setSelectedRoles,
  setSelectedApplications,
  setSelectedMarkets
}) => {
  const [availableRoleOptions, setAvailableRoleOptions] = useState(roleOptions);

  const [isApplicationsDisabled, setIsApplicationsDisabled] = useState(false);
  const [isMarketsDisabled, setIsMarketsDisabled] = useState(false);

  useEffect(() => {
    handleAvailableRoles(selectedAccessType?.id);

    switch (selectedAccessType?.id) {
      case accessTypes.applicationSpecific:
        disableMarkets();
        setIsApplicationsDisabled(false);
        break;

      case accessTypes.global:
        disableApplications();
        disableMarkets();
        break;

      case accessTypes.marketSpecific:
        setIsApplicationsDisabled(false);
        setIsMarketsDisabled(false);

        break;
    }
  }, [selectedAccessType]);

  const disableApplications = () => {
    setIsApplicationsDisabled(true);
    setSelectedApplications([]);
  };

  const disableMarkets = () => {
    setIsMarketsDisabled(true);
    setSelectedMarkets([]);
  };

  const handleAvailableRoles = (accessType) => {
    if (accessType) {
      const availableRoles = accessTypeRoles[accessType];
      const filteredRoleOptions = roleOptions.filter((role) => availableRoles.includes(role.id));

      setAvailableRoleOptions(filteredRoleOptions);
      setSelectedRoles((prev) => prev.filter((role) => availableRoles.includes(role.id)));
    }
  };

  return { availableRoleOptions, isApplicationsDisabled, isMarketsDisabled };
};
